import { createUseStyles } from 'react-jss';

export const useFilterStyles = createUseStyles({
  closeButton: {
    border: 'none',
    borderRadius: '2rem',
    height: '3rem',
    lineHeight: 1,
    padding: 0,
    verticalAlign: 'middle',
    width: '3rem',
  },
  moreButton: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  addFilterButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  cancelFilterBtn: {
    minWidth: '5rem',
    whiteSpace: 'nowrap',
  },
  addFilterBtn: {
    minWidth: '5rem',
    whiteSpace: 'nowrap',
  },
  firefoxText: {
    '@supports ( -moz-appearance:none )': {
      paddingTop: '0.22rem',
    },
  },
});

export const useSavedFilterStyles = createUseStyles({
  saveFilterButton: {
    width: '100%',
  },
  editSaveFilterButton: {
    height: '2rem',
    padding: 0,
    width: '2rem',
  },
  filterCardContent: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '0 !important',
    '&:last-child': {
      paddingBottom: '0 !important',
    },
  },
  filterNameCell: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    minHeight: '1.5rem',
    justifyContent: 'center',
    width: '100%',
    wordBreak: 'break-word',
  },
  filterChipContainer: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
    width: '100%',
  },
  filterActionsCell: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    padding: '0 1rem 1rem',
  },
  firefoxText: {
    '@supports ( -moz-appearance:none )': {
      paddingTop: '0.22rem',
    },
  },
});
